import { Button } from "@material-ui/core";
import StorageHelper from "../../Utility/StorageHelper";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { connect } from "react-redux";
import {
  getGraphProfile,
  signOutUser,
} from "../../Libraries/redux/reducers/Auth/reducer";
import { unwrapResult } from "@reduxjs/toolkit";


function MicrosoftLogin(Iprops: any) {
  const { instance, accounts } = useMsal();
  // const [graphData, setGraphData] = useState(null);

  const onSuccess = (data: any, token: string) => {
    let responseObj: any = {
      name: data?.displayName,
      email: data?.mail,
    };

    Iprops.handleLogin({ google_login: responseObj, tokenId: token });
  };



  const initiateLogin = async (_loginRequest) => {
    try {
      StorageHelper.set("initiated-microsoft", "1");
      console.log("MicrosoftLogin.tsx: Initiating Microsoft login popup...");
      const res = await instance.loginPopup({
        ..._loginRequest,
        prompt: "select_account",
        usePopup: true,
        pollIntervalMilliseconds: 0
      });

      console.log("MicrosoftLogin.tsx: MSAL loginPopup response:", res);
      if (res) {
        console.log("MicrosoftLogin.tsx: MSAL result found. Acquiring token silently...");

        // Acquire token silently
        const response = await instance.acquireTokenSilent({
          ..._loginRequest,
          account: res.account ?? accounts[0], // If no account provided, fallback to the first account in the list
        });

        console.log("MicrosoftLogin.tsx: MSAL acquireTokenSilent response:", response);

        // Fetch Graph profile using acquired token
        const graphProfile = await Iprops.getGraphProfile({
          token: response.accessToken,
        })
          .then(unwrapResult)
          .then(async (_res: any) => await _res);

        console.log("MicrosoftLogin.tsx: Graph Profile received:", graphProfile);

        if (graphProfile) {
          onSuccess(graphProfile, response.accessToken);
        } else {
          console.error("MicrosoftLogin.tsx: Graph profile is empty. Signing out user.");
          Iprops.signOutUser();
        }
      }
    } catch (error) {
      console.error("MicrosoftLogin.tsx: An error occurred during Microsoft login flow:", error);
    }
  };

  //   const initiateLogin = async (_loginRequest: any) => {
  //     try {
  //       StorageHelper.set("initiated-microsoft", "1");
  //       console.log("hi1");
  //       await instance
  //         .loginPopup({ ...loginRequest, prompt: "select_account" })
  //         .then(async (res) => {
  //           console.log("hi2");
  //           await instance.setActiveAccount(res.account);
  //           await instance
  //             .acquireTokenSilent({
  //               ...loginRequest,
  //               account: res.account ?? accounts[0],
  //             })
  //             .then(async (response) => {
  //               await Iprops.getGraphProfile({ token: response.accessToken })
  //                 .then(unwrapResult)
  //                 .then(async (_response) => {
  //                   await setGraphData(_response);
  //                 //   console.log(_response)
  //                   onSuccess(_response);
  //                 });
  //             });
  //         })
  //         .catch((error) => {
  //           console.error({ error });
  //         });
  //     } catch (error) {
  //       console.error({ error });
  //     }
  //   };

  const onSubmit = () => {
    console.log("Initiat Login")
    StorageHelper.clearAppStorage();
    initiateLogin(loginRequest);
  };



  return (
    <Button
      onClick={onSubmit}
      fullWidth
      style={{ backgroundColor: "#EA4335", color: "white", marginTop: "15px" }}
    >
      Continue with Microsoft
    </Button>
  );
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({
  getGraphProfile: (payload: any) => dispatch(getGraphProfile(payload)),
  signOutUser: (payload: any) => dispatch(signOutUser(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MicrosoftLogin);
